import React from "react";
import { useOutletContext } from "react-router-dom";
import { BackupPanel } from "../components/backup-panel.jsx";
import type { AdminOutletContext } from "../lib/outlet-context";

export function InfrastructureDatabaseBackupPage() {
  const { clients, api } = useOutletContext<AdminOutletContext>();
  return <BackupPanel clients={clients} api={api} />;
}
